import { render, staticRenderFns } from "./my-nav-menu.vue?vue&type=template&id=f193c224&scoped=true"
import script from "./my-nav-menu.vue?vue&type=script&lang=js"
export * from "./my-nav-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f193c224",
  null
  
)

export default component.exports